import { authenticatedFetch } from "./authFetch";

const API_BASE_URL = import.meta.env.VITE_BACKEND_API_URL;
const BATCH_SIZE = 200;

export async function fetchProgressBatch<T>(
  kind: "unit" | "lesson",
  studentId: string,
  ids: number[]
): Promise<T[]> {
  const uniqueIds = [...new Set(ids)];
  const rows: T[] = [];
  // Bound each payload and avoid flooding the backend for large catalogs.
  for (let offset = 0; offset < uniqueIds.length; offset += BATCH_SIZE) {
    const response = await authenticatedFetch(
      `${API_BASE_URL}/${kind}-progress/${encodeURIComponent(studentId)}/batch`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: uniqueIds.slice(offset, offset + BATCH_SIZE) }),
      },
      { studentId }
    );
    if (!response.ok) throw new Error(`Failed to fetch ${kind} progress`);
    rows.push(...(await response.json() as T[]));
  }
  return rows;
}

export function replaceRequestedProgress<T>(
  current: Record<string, T>,
  studentId: string,
  ids: number[],
  rows: Array<{ id: number; progress: T }>
): Record<string, T> {
  const next = { ...current };
  // An absent server row must not leave an old completion flag in memory.
  for (const id of ids) delete next[`${studentId}-${id}`];
  for (const { id, progress } of rows) next[`${studentId}-${id}`] = progress;
  return next;
}
